import { Button, CircularProgress, Collapse, IconButton, List, ListItem, ListItemIcon, Modal, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DocumentYellowIcon from 'Components/Icons/DocumentIconYellow';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { setAbortControllers, setPublishingBox, setReload, setUploadingMedia } from 'store/Announcements/actions';
import { useNavigate } from 'react-router';
import { FIVE_MEGA_BYTE } from 'store/constant';
import { createAnnouncements, updateAnnouncementDetail, uploadAnnouncementFile } from 'utils/apolloQueries';
import { formatTime } from 'helper/date.helper';
import { convertBytes, truncateFilename } from 'helper/string.helper';
import { UploadFile, uploadFileChunkGraphQL } from 'utils/functions';
import axios from 'utils/axios';
import { bytesToMB } from 'helper/number.helper';
import TrashIcon from 'Components/Icons/TrashIcon';
import { throttle } from 'lodash';
const accessToken = localStorage.getItem('diologAuthToken');
let uploadingMediaModified = [];
let controllerForAbortion = [];
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '570px',
    bgcolor: 'background.paper',
    borderRadius: '12px',
    p: 3
};

const UploadAlert = () => {
    const dispatch = useDispatch();
    const { uploadingMedia, showPublishingBox, abortControllers, items, reload } = useSelector((params) => params.announcements);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showDropdown, setShowDropdown] = useState(true);
    const [open, setOpen] = useState(false);
    const [closeModalOpen, setCloseModalOpen] = useState(false);
    const navigate = useNavigate();
    const { companyData } = useSelector((params) => params.customization);
    const [uploadingItems, setUploadingItems] = useState([]);
    useEffect(() => {
        const newUploadingMedia = uploadingMedia.map((item) => {
            const found = uploadingItems.find((elem) => item.id === elem.id);
            if (found && found?.isCancelled) {
                return {
                    ...item,
                    cancelledFromList: Boolean(found?.cancelledFromList)
                };
            } else {
                return item;
            }
        });
        if (!Boolean(getTotalItemsWithoutCancelledFromGivenArray(newUploadingMedia))) {
            dispatch({ type: setPublishingBox, showPublishingBox: false });
        }
        setUploadingItems(newUploadingMedia);
    }, [uploadingMedia]);

    const getUploadingAlertTitle = () => {
        const totalLength = uploadingMedia?.length;
        const totalUploadingStaus = uploadingMedia?.filter((item) => item.isLoading)?.length || 0;
        const draftedLoadingItem = uploadingMedia?.filter((item) => item.isLoading && item.type === 'draft')?.length;
        const isAllDrafted = draftedLoadingItem === uploadingMedia?.length;
        const completedItem = uploadingMedia?.filter((item) => item?.isCompleted)?.length;
        const isAllCompleted = completedItem === uploadingMedia?.length;
        return totalUploadingStaus > 1 && !isAllDrafted
            ? !isAllCompleted
                ? `Publishing announcement${totalLength > 1 ? 's' : ''}`
                : `Announcement published!`
            : uploadingMedia?.[uploadingMedia.length - 1]?.type === 'draft'
            ? !isAllCompleted
                ? `Drafting announcement${totalLength > 1 ? 's' : ''}`
                : `Announcement drafted!`
            : !isAllCompleted
            ? `Publishing announcement${totalLength > 1 ? 's' : ''}`
            : `Announcement published!`;
    };

    const getTextForCollapsing = () => {
        const draftedItem = uploadingMedia?.filter((item) => item.type === 'draft')?.length;
        const draftedCompletedItem = uploadingMedia?.filter((item) => item.type === 'draft' && item.isCompleted)?.length;
        const isAllDrafted = draftedItem === uploadingMedia?.length;
        const publishedItem = uploadingMedia?.filter((item) => item.type !== 'draft')?.length;
        const publishedCompletedItem = uploadingMedia?.filter((item) => item.type !== 'draft' && item.isCompleted)?.length;
        const isAllPublished = publishedItem === uploadingMedia?.length;

        return isAllPublished || isAllDrafted
            ? `${getTotalPublishedItems()} out of ${getTotalItemsWithoutCancelled()} ${isAllDrafted ? 'drafted' : 'published'}`
            : `${publishedCompletedItem} announcement${
                  publishedCompletedItem > 1 ? 's' : ''
              } published and ${draftedCompletedItem} drafted`;
    };

    useEffect(() => {
        // Throttling the dispatch call to avoid rapid updates
        const throttledDispatch = throttle((items) => {
            dispatch({ type: setUploadingMedia, uploadingMedia: items });
        }, 5000);

        // Set up the interval
        let intervalId = setInterval(() => {
            setUploadingItems((prevState) => {
                const items = prevState.map((item) => (item.isCancelled ? { ...item, cancelledFromList: true } : item));

                throttledDispatch(items); // Throttle the dispatch calls
                return items;
            });
        }, 5000);

        // Cleanup function to avoid memory leaks
        return () => {
            clearInterval(intervalId);
            throttledDispatch.cancel(); // Cancel the throttled dispatch on unmount
        };
    }, [dispatch]);

    const alertTitle = getUploadingAlertTitle();
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleOpenCloseModal = () => setCloseModalOpen(true);
    const handleCloseCloseModal = () => setCloseModalOpen(false);
    const onClickCLoseCancel = (elem) => {
        const newUploadingMedia = [...uploadingMedia];
        const index = uploadingMedia.findIndex((item) => item.id === elem.id);
        if (newUploadingMedia[index].isLoading) {
            const controller = abortControllers?.find((item) => item.id === elem.id);
            if (controller) {
                controller.controller.abort();
            }
        }
        if (index >= 0) {
            newUploadingMedia[index].loader = 0;
            newUploadingMedia[index].remainingTime = `0 seconds`;
            newUploadingMedia[index].isLoading = false;
            newUploadingMedia[index].isCancelled = true;
            newUploadingMedia[index].isError = false;
        }
        dispatch({
            type: setUploadingMedia,
            uploadingMedia: [...newUploadingMedia]
        });
        uploadingMediaModified = [...newUploadingMedia];
    };
    const onClickCloseModalOpen = (elem) => {
        setSelectedItem(elem);
        handleOpenCloseModal(true);
    };
    useEffect(() => {
        // if (!uploadingMedia.length) {
        //     // if (!showDropdown) {
        //     //     setShowDropdown(true);
        //     // }
        //     dispatch({ type: setPublishingBox, showPublishingBox: false });
        // }
        uploadingMediaModified = [...uploadingMedia];
    }, [uploadingMedia]);
    useEffect(() => {
        controllerForAbortion = [...abortControllers];
    }, [abortControllers]);

    const onViewAnnouncement = (elem) => {
        const selectedItemFromList = items.find((item) => item._id === elem.id);
        dispatch({ type: setSelectedItem, selectedItem: selectedItemFromList || { _id: elem.id, title: elem.title } });
        discardItem(elem);
        navigate(`/dashboard/announcements/${elem.id}`);
    };
    const onRetryUpload = (elem) => {
        saveV2(elem);
    };

    const saveV2 = async (elem) => {
        try {
            let totalPageNo = 1;
            let fileName = '';
            let media = false;
            let file = {};
            if (elem?.file) {
                if (elem?.file?.type === 'audio/mpeg' || elem?.file?.type === 'video/mp4') {
                    media = true;
                }
                if (elem?.file?.type === 'application/pdf') {
                    totalPageNo = elem.pageNumber;
                }
                fileName = elem.id;
                if (elem?.file?.size >= FIVE_MEGA_BYTE)
                    file = await handleUpload(elem.file, fileName, uploadingMediaModified, controllerForAbortion, elem.title);
                else file = await handleFileUploadSmall(elem.file, fileName, uploadingMediaModified, controllerForAbortion, 0, elem.title);
            }
            let fileKey = file?.key || '';
            let thumbnailKey = file?.thumbnailKey || '';
            let attachmentDuration = file?.attachmentDuration || 0;
            let variables = {
                announcementInput: {
                    attachment: fileKey,
                    attachmentThumbnail: thumbnailKey,
                    attachmentDuration: attachmentDuration,
                    attachmentSize: elem?.file?.size || 0,
                    attachmentTotalPages: totalPageNo,
                    companyId: companyData._id,
                    media: media,
                    status: elem.type,
                    title: elem.title
                }
            };
            const idx = uploadingMediaModified?.findIndex((item) => item.id === fileName);
            const announcmentId = uploadingMediaModified?.[idx]?.announcementId || null;
            let query = createAnnouncements;
            if (announcmentId) {
                variables = {
                    announcementInput: {
                        ...variables.announcementInput,
                        announcementId: announcmentId
                    }
                };
                query = updateAnnouncementDetail;
            }
            const submitData = { query: query, variables: variables };
            axios({
                method: 'POST',
                data: submitData,
                headers: {
                    Authorization: accessToken
                }
            })
                .then(function (response) {
                    if (response.status === 200) {
                        if (response?.data) {
                            if (response?.data?.data) {
                                if (fileName) {
                                    const index = uploadingMediaModified?.findIndex((item) => item.id === fileName);
                                    if (index >= 0) {
                                        uploadingMediaModified[index].loader = 0;
                                        uploadingMediaModified[index].isLoading = false;
                                        uploadingMediaModified[index].remainingTime = `0 seconds`;
                                        uploadingMediaModified[index].id =
                                            response?.data?.data?.createAnnouncement?._id || response?.data?.data?.updateAnnouncement?._id;
                                        uploadingMediaModified[index].isError = false;
                                        uploadingMediaModified[index].isCancelled = false;
                                        uploadingMediaModified[index].isCompleted = true;
                                        dispatch({
                                            type: setUploadingMedia,
                                            uploadingMedia: [...uploadingMediaModified]
                                        });
                                    }
                                }
                                dispatch({ type: setReload, reload: !reload });
                            } else {
                                const index = uploadingMediaModified?.findIndex((item) => item.id === fileName);
                                if (index >= 0) {
                                    uploadingMediaModified[index].loader = 0;
                                    uploadingMediaModified[index].isLoading = false;
                                    uploadingMediaModified[index].remainingTime = `0 seconds`;
                                    uploadingMediaModified[index].isError = true;
                                    uploadingMediaModified[index].isCancelled = false;
                                    uploadingMediaModified[index].isCompleted = false;
                                    dispatch({
                                        type: setUploadingMedia,
                                        uploadingMedia: [...uploadingMediaModified]
                                    });
                                }
                            }
                        }
                    } else {
                        const index = uploadingMediaModified?.findIndex((item) => item.id === fileName);
                        if (index >= 0) {
                            uploadingMediaModified[index].loader = 0;
                            uploadingMediaModified[index].isLoading = false;
                            uploadingMediaModified[index].remainingTime = `0 seconds`;
                            uploadingMediaModified[index].isError = true;
                            uploadingMediaModified[index].isCancelled = false;
                            uploadingMediaModified[index].isCompleted = false;
                            dispatch({
                                type: setUploadingMedia,
                                uploadingMedia: [...uploadingMediaModified]
                            });
                        }
                    }
                })
                .catch(function () {
                    const index = uploadingMediaModified?.findIndex((item) => item.id === fileName);
                    if (index >= 0) {
                        uploadingMediaModified[index].loader = 0;
                        uploadingMediaModified[index].isLoading = false;
                        uploadingMediaModified[index].remainingTime = `0 seconds`;
                        uploadingMediaModified[index].isError = true;
                        uploadingMediaModified[index].isCancelled = false;
                        uploadingMediaModified[index].isCompleted = false;
                        dispatch({
                            type: setUploadingMedia,
                            uploadingMedia: [...uploadingMediaModified]
                        });
                    }
                    // Announcement added failed
                    // dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: true, variant: 'error', message: 'Something went wrong while trying to upload the announcement. Please try again later' } });
                });
        } catch (e) {
            console.log(e);
        } finally {
            if (selectedItem) {
                if (closeModalOpen) {
                    handleCloseCloseModal(true);
                }
            }
        }
    };

    const removeAbortController = (id) => {
        const filteredAbortController = controllerForAbortion?.filter((item) => item.id !== id);
        dispatch({ type: setAbortControllers, abortControllers: [...filteredAbortController] });
        return filteredAbortController;
    };
    const handleFileUploadSmall = async (file, fileName, loader) => {
        let remainingTime = 4 * bytesToMB(file.size);
        remainingTime = remainingTime || 1;
        let currentController = controllerForAbortion?.find((item) => item.id === fileName);
        if (!currentController) {
            currentController = new AbortController();
        } else {
            currentController = currentController?.controller;
        }
        controllerForAbortion = [...controllerForAbortion, { id: fileName, controller: currentController }];
        dispatch({
            type: setAbortControllers,
            abortControllers: [...controllerForAbortion]
        });
        dispatch({ type: setPublishingBox, showPublishingBox: true });
        const newIntervalId = setInterval(() => {
            loader += 5;
            if (remainingTime > 1) remainingTime = remainingTime - remainingTime / 20;
            if (loader === 100) clearInterval(newIntervalId);
            const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
            if (index >= 0) {
                // if (uploadingMediaModified[index]?.isError) {
                //     clearInterval(newIntervalId);
                //     return;
                // }
                uploadingMediaModified[index].loader = Math.round(loader);
                uploadingMediaModified[index].remainingTime = `${formatTime(remainingTime)}`;
                uploadingMediaModified[index].id = fileName;
                uploadingMediaModified[index].isLoading = true;
                uploadingMediaModified[index].isError = false;
                uploadingMediaModified[index].isCancelled = false;
                uploadingMediaModified[index].isCompleted = false;
            }
            dispatch({
                type: setUploadingMedia,
                uploadingMedia: [...uploadingMediaModified]
            });
        }, 1);
        const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
        if (index >= 0) {
            uploadingMediaModified[index].loader = Math.round(loader);
            uploadingMediaModified[index].remainingTime = `${formatTime(remainingTime)}`;
            uploadingMediaModified[index].id = fileName;
            uploadingMediaModified[index].isLoading = true;
            uploadingMediaModified[index].isError = false;
            uploadingMediaModified[index].isCancelled = false;
            uploadingMediaModified[index].isCompleted = false;
        }
        uploadingMediaModified = [...uploadingMediaModified];
        dispatch({
            type: setUploadingMedia,
            uploadingMedia: [...uploadingMediaModified]
        });
        try {
            file = await UploadFile(file, uploadAnnouncementFile, false, currentController.signal);
            if (file?.uploadAnnouncementFile) {
                clearInterval(newIntervalId);
                return {
                    ...file.uploadAnnouncementFile,
                    uploadingMediaModified
                };
            } else {
                const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                if (index >= 0) {
                    uploadingMediaModified[index].loader = 0;
                    uploadingMediaModified[index].remainingTime = `0 second`;
                    uploadingMediaModified[index].isLoading = false;
                    uploadingMediaModified[index].isError = true;
                    uploadingMediaModified[index].isCancelled = false;
                    uploadingMediaModified[index].isCompleted = false;
                }

                dispatch({
                    type: setUploadingMedia,
                    uploadingMedia: [...uploadingMediaModified]
                });
                clearInterval(newIntervalId);
                return {
                    uploadingMediaModified
                };
            }
        } catch (e) {
            if (e.message === 'canceled') {
                if (uploadingMediaModified.length) {
                    const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                    if (index >= 0) {
                        uploadingMediaModified[index].loader = 0;
                        uploadingMediaModified[index].remainingTime = `0 seconds`;
                        uploadingMediaModified[index].isLoading = false;
                        uploadingMediaModified[index].isError = false;
                        uploadingMediaModified[index].isCancelled = true;
                        uploadingMediaModified[index].isCompleted = false;
                    }

                    dispatch({
                        type: setUploadingMedia,
                        uploadingMedia: [...uploadingMediaModified]
                    });
                    clearInterval(newIntervalId);
                    throw e;
                }
            } else {
                if (uploadingMediaModified.length) {
                    const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                    if (index >= 0) {
                        uploadingMediaModified[index].loader = 0;
                        uploadingMediaModified[index].remainingTime = `0 seconds`;
                        uploadingMediaModified[index].isLoading = false;
                        uploadingMediaModified[index].isError = true;
                        uploadingMediaModified[index].isCancelled = false;
                        uploadingMediaModified[index].isCompleted = false;
                    }

                    dispatch({
                        type: setUploadingMedia,
                        uploadingMedia: [...uploadingMediaModified]
                    });
                    clearInterval(newIntervalId);
                    throw e;
                }
            }
        } finally {
            removeAbortController(fileName);
        }
    };

    const handleUpload = async (file, fileName, title) => {
        const minChunkSize = 5 * 1024 * 1024; // 1 MB minimum chunk size

        return new Promise((resolve) => {
            const chunkSize = 5 * 1024 * 1024; // 1KB chunk size
            let totalChunks = Math.ceil(file.size / chunkSize);
            let chunkIndex = 0;
            let bytesUploaded = 0;
            const startTime = Date.now();
            const fileReader = new FileReader();
            let fileData;
            let progress = 0; // Calculate progress percentage
            let elapsedTime = 0; // Elapsed time in seconds
            let uploadSpeed = 0; // Upload speed in bytes per second
            let remainingBytes = 0;
            let remainingTime = 0;
            dispatch({ type: setPublishingBox, showPublishingBox: true });
            fileReader.onload = async (e) => {
                let currentController = controllerForAbortion?.find((item) => item.id === fileName);
                if (!currentController) {
                    currentController = new AbortController();
                } else {
                    currentController = currentController?.controller;
                }
                controllerForAbortion = [...controllerForAbortion, { id: fileName, controller: currentController }];
                dispatch({
                    type: setAbortControllers,
                    abortControllers: [...controllerForAbortion]
                });
                if (currentController?.signal?.aborted) return; // Check if upload has been aborted before proceeding
                let chunk = e.target.result;
                // bytesUploaded += chunk.byteLength; // Update bytesUploaded
                bytesUploaded += chunk.byteLength; // Update bytesUploaded
                progress = (bytesUploaded / file.size) * 100; // Calculate progress percentage
                elapsedTime = (Date.now() - startTime) / 1000; // Elapsed time in seconds
                uploadSpeed = bytesUploaded / elapsedTime; // Upload speed in bytes per second
                remainingBytes = file.size - bytesUploaded;
                remainingTime = remainingBytes / uploadSpeed; // Estimated remaining time in seconds

                if (uploadingMediaModified.length) {
                    const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                    if (index >= 0) {
                        uploadingMediaModified[index].loader = Math.round(progress);
                        uploadingMediaModified[index].remainingTime = `${formatTime(remainingTime)}`;
                        uploadingMediaModified[index].id = fileName;
                        uploadingMediaModified[index].isLoading = true;
                        uploadingMediaModified[index].isError = false;
                        uploadingMediaModified[index].isCancelled = false;
                        uploadingMediaModified[index].isCompleted = false;
                    } else {
                        const formattedTime = formatTime(remainingTime);
                        uploadingMediaModified = [
                            ...uploadingMediaModified,
                            {
                                name: file.name,
                                id: fileName,
                                size: convertBytes(file.size),
                                loader: 0,
                                isLoading: true,
                                totalTime: '5:00 mins',
                                remainingTime: formattedTime,
                                isError: false,
                                isCompleted: false,
                                isCancelled: false
                            }
                        ];
                    }
                } else {
                    const formattedTime2 = formatTime(remainingTime);
                    uploadingMediaModified = [
                        ...uploadingMediaModified,
                        {
                            name: file.name,
                            title: title,
                            id: fileName,
                            size: convertBytes(file.size),
                            loader: 0,
                            isLoading: true,
                            totalTime: '5:00 mins',
                            remainingTime: formattedTime2,
                            isError: false,
                            isCompleted: false,
                            isCancelled: false
                        }
                    ];
                }
                dispatch({
                    type: setUploadingMedia,
                    uploadingMedia: [...uploadingMediaModified]
                });

                try {
                    fileData = await uploadFileChunkGraphQL(chunk, chunkIndex, totalChunks, fileName, currentController.signal); // Pass signal to uploadChunk
                    const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                    if (index >= 0) {
                        uploadingMediaModified[index].loader = Math.round(progress);
                        //uploadingMediaModified[index].remainingTime = `${formatTime(remainingTime)}`;
                        uploadingMediaModified[index].id = fileName;
                        uploadingMediaModified[index].isLoading = true;
                        uploadingMediaModified[index].isError = false;
                        uploadingMediaModified[index].isCancelled = false;
                        uploadingMediaModified[index].isCompleted = false;
                        dispatch({
                            type: setUploadingMedia,
                            uploadingMedia: [...uploadingMediaModified]
                        });
                    }
                } catch (e) {
                    if (e.message === 'canceled') {
                        if (uploadingMediaModified.length) {
                            const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                            if (index >= 0) {
                                uploadingMediaModified[index].loader = 0;
                                uploadingMediaModified[index].remainingTime = `0 seconds`;
                                uploadingMediaModified[index].isLoading = false;
                                uploadingMediaModified[index].isError = false;
                                uploadingMediaModified[index].isCancelled = true;
                                uploadingMediaModified[index].isCompleted = false;
                            }

                            dispatch({
                                type: setUploadingMedia,
                                uploadingMedia: [...uploadingMediaModified]
                            });

                            return;
                        }
                    } else {
                        if (uploadingMediaModified.length) {
                            const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                            if (index >= 0) {
                                uploadingMediaModified[index].loader = 0;
                                uploadingMediaModified[index].remainingTime = `0 seconds`;
                                uploadingMediaModified[index].isLoading = false;
                                uploadingMediaModified[index].isError = true;
                                uploadingMediaModified[index].isCancelled = false;
                                uploadingMediaModified[index].isCompleted = false;
                            }

                            dispatch({
                                type: setUploadingMedia,
                                uploadingMedia: [...uploadingMediaModified]
                            });

                            return;
                        }
                    }
                }
                chunkIndex++;
                if (chunkIndex < totalChunks) {
                    controllerForAbortion = removeAbortController(fileName);
                    readNextChunk(file);
                } else {
                    controllerForAbortion = removeAbortController(fileName);
                    if (fileData?.data?.uploadChunk)
                        resolve({ ...fileData?.data?.uploadChunk, uploadingMediaModified, controllerForAbortion });
                    else {
                        if (uploadingMediaModified.length) {
                            const index = uploadingMediaModified.findIndex((item) => item.id === fileName);
                            if (index >= 0) {
                                uploadingMediaModified[index].loader = 0;
                                uploadingMediaModified[index].remainingTime = `0 second`;
                                uploadingMediaModified[index].isLoading = false;
                                uploadingMediaModified[index].isError = true;
                                uploadingMediaModified[index].isCancelled = false;
                                uploadingMediaModified[index].isCompleted = false;
                            }

                            dispatch({
                                type: setUploadingMedia,
                                uploadingMedia: [...uploadingMediaModified]
                            });

                            resolve({ uploadingMediaModified, controllerForAbortion });
                        }
                    }
                }
            };

            const readNextChunk = (newFile) => {
                let end = Math.min(bytesUploaded + minChunkSize, newFile.size);
                let chunk = newFile.slice(bytesUploaded, end);

                // Check if the chunk size is less than 5MB
                let remainingSpace = newFile.size - bytesUploaded - chunkSize;
                let additionalData = newFile.slice(end, end + remainingSpace);
                if (remainingSpace < minChunkSize) {
                    chunk = new Blob([chunk, additionalData]);
                    totalChunks--;
                }
                // Check if the next chunk is below 5MB and append it to the current chunk

                fileReader.readAsArrayBuffer(chunk);
            };

            readNextChunk(file);
        });
    };
    const discardItem = (item) => {
        const modifiedUploadingMedia = uploadingMedia.filter((elem) => item.id !== elem.id);
        dispatch({
            type: setUploadingMedia,
            uploadingMedia: [...modifiedUploadingMedia]
        });
        uploadingMediaModified = [...modifiedUploadingMedia];
    };
    const getTotalPublishedItems = () => {
        return uploadingItems.filter((item) => item.isCompleted).length;
    };
    const getTotalItemsWithoutCancelled = () => {
        return uploadingItems.filter((item) => !item?.cancelledFromList).length;
    };
    const getTotalItemsWithoutCancelledFromGivenArray = (medias) => {
        return medias.filter((item) => !item?.cancelledFromList).length;
    };
    return (
        <Box id="uploading-announcement-box" className={`large-file-loading ${showPublishingBox ? 'show' : ''}`}>
            <Stack
                direction="row"
                justifyContent="space-between"
                sx={{
                    padding: '18px 24px'
                }}
            >
                <Typography fontSize="1rem" fontFamily="Poppins" fontWeight="600">
                    {alertTitle}
                </Typography>

                <Stack direction="row">
                    <IconButton
                        className="arrow"
                        disableRipple
                        onClick={() => {
                            setShowDropdown(!showDropdown);
                        }}
                    >
                        {showDropdown ? <KeyboardArrowDownRoundedIcon /> : <KeyboardArrowUpRoundedIcon />}
                    </IconButton>
                    <IconButton
                        className="close"
                        disableRipple
                        onClick={() => {
                            dispatch({ type: setPublishingBox, showPublishingBox: !showPublishingBox });
                        }}
                    >
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
            </Stack>

            <Collapse orientation="vertical" in={showDropdown}>
                <Box
                    sx={{
                        borderTop: '1px solid rgba(255, 255, 255, 0.25)'
                    }}
                >
                    <List>
                        {uploadingItems
                            .filter((uploadingItem) => !uploadingItem?.cancelledFromList)
                            .map((item) => {
                                return (
                                    <ListItem className={`${item.isError ? ' failed' : null} ${item.isCancelled ? 'cancelled' : null}`}>
                                        <ListItemIcon>
                                            {item.isLoading ? (
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={item.loader}
                                                    size={'small'}
                                                    className="loading-progress"
                                                />
                                            ) : (
                                                <DocumentYellowIcon />
                                            )}
                                        </ListItemIcon>
                                        <Stack rowGap="4px">
                                            <Typography fontSize="1rem">{truncateFilename(item.name, 30)}</Typography>
                                            {item.isLoading && (
                                                <Typography color="#B1B1B4" fontSize="0.8125rem">
                                                    {item.size} •{' '}
                                                    {item.remainingTime === 'Calculating time...'
                                                        ? `${item.remainingTime}`
                                                        : `${item.remainingTime} left`}
                                                </Typography>
                                            )}
                                            {item.isCompleted && (
                                                <Typography color="#B1B1B4" fontSize="0.8125rem">
                                                    {item.size} •{' '}
                                                    <Button variant="text" disableRipple onClick={() => onViewAnnouncement(item)}>
                                                        View announcement
                                                    </Button>
                                                </Typography>
                                            )}
                                            {item.isCancelled && (
                                                <Typography color="#B1B1B4" fontSize="0.8125rem">
                                                    Publishing has been cancelled
                                                </Typography>
                                            )}
                                            {item.isError && (
                                                <Stack
                                                    direction="row"
                                                    flexWrap="wrap"
                                                    alignItems="center"
                                                    color="#B1B1B4"
                                                    fontSize="0.8125rem"
                                                    gap={0.5}
                                                >
                                                    <Typography color="#FF3E4A" fontSize="0.8125rem">
                                                        Announcement failed to upload
                                                    </Typography>
                                                    •
                                                    <Button variant="text" disableRipple onClick={() => onRetryUpload(item)}>
                                                        Retry upload
                                                    </Button>
                                                </Stack>
                                            )}
                                        </Stack>
                                        {item.isLoading || item.isError ? (
                                            <IconButton
                                                className="close"
                                                disableRipple
                                                onClick={() => {
                                                    if (item.isLoading) onClickCloseModalOpen(item);
                                                    else if (item.isError) {
                                                        setSelectedItem(item);
                                                        handleOpen();
                                                    } else {
                                                        discardItem(item);
                                                    }
                                                }}
                                            >
                                                <CloseRoundedIcon />
                                            </IconButton>
                                        ) : null}
                                    </ListItem>
                                );
                            })}
                    </List>
                </Box>
            </Collapse>

            <Collapse orientation="vertical" in={!showDropdown}>
                <Box
                    sx={{
                        padding: '16px 24px',
                        borderTop: '1px solid rgba(255, 255, 255, 0.25)'
                    }}
                >
                    <Typography fontSize="1rem" lineHeight={2}>
                        {getTextForCollapsing()}
                    </Typography>
                </Box>
            </Collapse>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Stack rowGap={4}>
                        <Typography
                            id="modal-modal-title"
                            fontFamily="poppins"
                            variant="h3"
                            component="h2"
                            color="#00214D"
                            fontWeight="400"
                        >
                            Discard announcement?
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ fontWeight: '500', color: '#00214D' }}>
                            All progress in uploading the announcement will be discarded.
                        </Typography>

                        <Stack direction="row" justifyContent="space-between">
                            <Button
                                type="text"
                                disableRipple
                                onClick={handleClose}
                                size="large"
                                sx={{
                                    color: '#00214D',

                                    '&:hover': {
                                        background: '#fcb413 '
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                            <Stack direction="row" gap={2}>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    startIcon={<TrashIcon />}
                                    onClick={() => {
                                        if (selectedItem) discardItem(selectedItem);
                                        setSelectedItem(null);
                                        handleClose();
                                    }}
                                    size="large"
                                >
                                    Discard
                                </Button>
                                <Button
                                    disableRipple
                                    className="alternate"
                                    onClick={() => {
                                        if (selectedItem) saveV2(selectedItem);
                                        setSelectedItem(null);
                                        handleClose();
                                    }}
                                >
                                    Retry uploading
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={closeModalOpen}
                onClose={handleCloseCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack rowGap={4}>
                        <Typography
                            id="modal-modal-title"
                            fontFamily="poppins"
                            variant="h3"
                            component="h2"
                            color="#00214D"
                            fontWeight="400"
                        >
                            Cancel publishing announcement?
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ fontWeight: '500', color: '#00214D' }}>
                            All progress in uploading the announcement will be discarded.
                        </Typography>

                        <Stack direction="row" justifyContent="end" gap={2}>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<TrashIcon />}
                                onClick={() => {
                                    onClickCLoseCancel(selectedItem);
                                    handleCloseCloseModal();
                                }}
                                size="large"
                                // sx={{
                                //     '.MuiButton-startIcon': {
                                //         svg: {
                                //             path: {
                                //                 fill: '#fff'
                                //             }
                                //         }
                                //     },
                                //     '&:hover': {
                                //         '.MuiButton-startIcon': {
                                //             svg: {
                                //                 path: {
                                //                     fill: '#fb0d1b'
                                //                 }
                                //             }
                                //         }
                                //     }
                                // }}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableRipple
                                className="alternate"
                                onClick={() => {
                                    handleCloseCloseModal();
                                }}
                            >
                                Resume upload
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </Box>
    );
};
export default UploadAlert;
